<template>
  <div class="bottom-row">
    <div v-for="type in Object.keys(selection)" :key="type" class="col">
      <SelectedEntitiesGroup
        :title="type"
        :entity-ids="selection[type]"
        :entity-names="dataService.mapIdsToNames(type, selection[type])"
        :colored="colored === type"
        :advice-text="adviceTexts[type]"
        :description="descriptions[type]"
        @close-entity="removeEntity(type, $event)"
        @close-all="removeAllEntities(type)"
        @colored-change="selectColor(type)"
        @select-all="selectAll(type)"
      ></SelectedEntitiesGroup>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
import SelectedEntitiesGroup from "./SelectedEntitiesGroup.vue";

export default {
  components: {
    SelectedEntitiesGroup
  },
  props: {
    bus: { type: Object, required: true }
  },
  data: function() {
    return {
      selection: {
        nodes: [],
        timesteps: [],
        variants: []
      },
      colored: undefined,
      adviceTexts: {
        nodes:
          "No node selected&mdash;select a node by clicking on one in the graph view",
        timesteps:
          "No timestep selected&mdash;select a timestep by clicking on the respective label or column in the grid view",
        variants:
          "No variant selected&mdash;select a variant by clicking on the respective label or row in the grid view"
      },
      descriptions: {
        nodes:
          "Nodes represent the objects in a graph that are connected by edges",
        timesteps:
          "Timesteps represent the different stages of the dynamic graphs; for a variant, each timestep is assigned a static graph",
        variants:
          "Variants are alternative representations or versions of a dynamic graph that are intended to be compared"
      }
    };
  },
  created() {
    this.dataService = this.$dataService;
    this.colorService = this.$colorService;
    this.bus.$on(constants.NODE_SELECTED_EVENT, this.nodeSelected);
    this.bus.$on(constants.VTS_SELECTED_EVENT, this.vtsSelected);
  },
  methods: {
    selectColor(mode) {
      const eventMapping = {
        nodes: constants.COLORING_TYPE.NODES,
        timesteps: constants.COLORING_TYPE.TIMESTEPS,
        variants: constants.COLORING_TYPE.VARIANTS
      };
      this.colorService.clear();
      this.colored = mode;
      this.bus.$emit(constants.COLORING_EVENT, eventMapping[mode]);
    },
    nodeSelected: function(selection) {
      this.selection.nodes = Array.from(selection.nodes);
    },
    vtsSelected: function(selection) {
      this.selection.timesteps = Array.from(selection.timesteps);
      this.selection.variants = Array.from(selection.variants);
    },
    removeEntity(type, entity) {
      this.selection[type] = this.selection[type].filter(v => v !== entity);
      this.emitSelectionChangeEvent(type);
    },
    removeAllEntities(type) {
      this.selection[type] = [];
      this.emitSelectionChangeEvent(type);
    },
    // TODO: unify events for nodes and VTS (remove if-else)
    emitSelectionChangeEvent(type) {
      if (type === "nodes") {
        this.bus.$emit(constants.NODE_SELECTED_EVENT, {
          nodes: new Set(this.selection.nodes),
          source: constants.COMPONENT_NAMES.SELECTION_DETAILS
        });
      } else {
        this.bus.$emit(constants.VTS_SELECTED_EVENT, {
          timesteps: new Set(this.selection.timesteps),
          variants: new Set(this.selection.variants),
          source: constants.COMPONENT_NAMES.SELECTION_DETAILS
        });
      }
    },
    selectAll(type) {
      this.selection[type] = this.dataService.dataIds[type];
      this.emitSelectionChangeEvent(type);
    }
  }
};
</script>
